import EventDetailEventsAction from '@/screens/EventDetailEventsAction';

export default function PrivateEventEventIdEventsActionIndexRoute() {
  return <EventDetailEventsAction />;
}
